import $ from 'jquery';
import Animation from '../../modules/animation/animation';
import Numbered from 'input.numbered';

export default class {
	constructor(options) {
		const defaults = {
			el: '#auth',
			dom: {
				form: '#authForm',
				phone: '#authPhone',
				code: '#authCode',
				resend: '#authResend'
			},
			classes: {
				send: 'auth__form_send'
			}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = (this.options.el instanceof $) ? this.options.el : $(this.options.el);
		this.$window = $(window);
		this.sendPhone = false;
		return this;
	}

	get() {
		const {form, phone, code, resend} = this.options.dom;
		this.$form = this.$el.find(form);
		this.$phone = this.$el.find(phone);
		this.$code = this.$el.find(code);
		this.$resend = this.$el.find(resend);
		return this;
	}

	sendCode() {
		const self = this;
		$.ajax({
			url: self.$form.data('send'),
			type: self.$form.attr('method'),
			data: {phone: self.$phone.val().replace(/[^\d]/gi, '')},
			dataType: 'json',
			success: function (json) {
				if (json && json.success) {
					self.$form.addClass(self.options.classes.send);
				}else if (json.message) {
					alert(json.message);
				}
			}
		});
	}

	sendConfim() {
		const self = this;
		$.ajax({
			url: self.$form.attr('action'),
			type: self.$form.attr('method'),
			data: {
				phone: self.$phone.val().replace(/[^\d]/gi, ''),
				code: self.$code.val().trim()
			},
			dataType: 'json',
			success: function (json) {
				if (json && json.success) {
					self.$window.trigger('info.send');
				}else if (json.message) {
					alert(json.message);
				}
			}
		});
	}

	onSubmit = event => {
		event.preventDefault();
		let error = false;

		if (!this.$form.hasClass(this.options.classes.send)) {
			if (this.phone.validate() <= 0) {
				this.$phone.trigger('error');
				$(() => new Animation({el: this.$phone.parent()}).play('shake'));
			}else {
				this.sendPhone = this.$phone.val().replace(/[^\d]/gi, '');
				//this.sendCode();
				this.$form.addClass(this.options.classes.send);
                alert('В этот момент пользователю приходило SMS с кодом подтверждения.\n' +
                    'Сейчас мы смотрим сайт в демо-режиме, поэтому вы можете ввести ЛЮБЫЕ цифры.');
			}
		}else {
			if (this.phone.validate() <= 0) {
				error = true;
				this.$phone.trigger('error');
				$(() => new Animation({el: this.$phone.parent()}).play('shake'));
			}

			if (this.$code.val().trim() === '') {
				error = true;
				this.$code.trigger('error');
				$(() => new Animation({el: this.$code.parent()}).play('shake'));
			}

			if (!error) {
				// this.sendConfim();
				this.$window.trigger('info.send');
			}
		}
	}

	onChange() {
		const phone = this.$phone.val().replace(/[^\d]/gi, '');
		if (phone !== this.sendPhone) {
			this.$form.removeClass(this.options.classes.send);
		}
	}


	onClear() {
		this.$phone.val('').attr('value', '').trigger('change focus blur');
		this.$code.val('').attr('value', '').trigger('change focus blur');
		this.$form.removeClass(this.options.classes.send);
		this.sendPhone = false;
	}

	init() {
		this.phone = new Numbered(this.$phone, {placeholder: false});
		this.$form.on('submit', this.onSubmit.bind(this));
		this.$phone.on('change input', this.onChange.bind(this));
		this.$resend.on('click', this.sendCode.bind(this));
		this.$window.on('auth.clear', this.onClear.bind(this));
	}

	render() {
		if (this.$el.length) {
			this
				.get()
				.init();
		}
	}
}



// WEBPACK FOOTER //
// ./app/blocks/auth/auth.js